// @flow

import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'

type Props = {
  children: React.Node
}

type State = {
  hasError: boolean
}

export class ErrorBoundary extends React.Component<Props, State> {
  state = {
    hasError: false
  }

  componentDidCatch (error, info) {
    this.setState({ hasError: true })
    console.group('ErrorBoundary')
    console.log(error, info)
    console.groupEnd()
  }

  render () {
    if (this.state.hasError) {
      return (
        <div className='ui error icon message'>
          <i className='warning sign icon' />
          <div className='content'>
            <div className='header'>Une erreur est survenue</div>
            <p>
              Une erreur empêche cette partie du site de fonctionner.
            </p>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}



// WEBPACK FOOTER //
// ./src/components/errorBoundary/index.js